import { MapBoundsType } from "globals/types/globals.ts";

export const OSMStyle = {
  "version": 8,
  "sources": {
    "osm": {
      "type": "raster",
      "tiles": ["https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"],
      "tileSize": 256,
      "attribution": "&copy; OpenStreetMap Contributors",
      "maxzoom": 19
    }
  },
  "layers": [
    {
      "id": "osm",
      "type": "raster",
      "source": "osm" // This must match the source key above
    }
  ]
};


export const getExtendedBounds = (bounds: MapBoundsType): MapBoundsType => {
  const finalBounds = {
    northLat: bounds.northLat ? Math.ceil(bounds.northLat) : null,
    westLng: bounds.westLng ? Math.floor(bounds.westLng) : null,
    southLat: bounds.southLat ? Math.floor(bounds.southLat) : null,
    eastLng: bounds.eastLng ? Math.ceil(bounds.eastLng) : null
  };
  return finalBounds;
};
